var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.84661 6.94614C3.7905 6.94425 3.73537 6.93092 3.68459 6.90697C3.63381 6.88302 3.58847 6.84895 3.55132 6.80685L0.765608 4.02114C0.712494 3.9867 0.667899 3.94065 0.635188 3.88646C0.602478 3.83226 0.582507 3.77134 0.576784 3.7083C0.571062 3.64526 0.579736 3.58175 0.602153 3.52255C0.624571 3.46335 0.660144 3.41002 0.706188 3.36658C0.752233 3.32314 0.807544 3.29073 0.867946 3.2718C0.928349 3.25287 0.992263 3.2479 1.05486 3.25729C1.11747 3.26667 1.17712 3.29015 1.22931 3.32596C1.28151 3.36177 1.32489 3.40897 1.35618 3.464L3.84661 5.93771L9.67989 0.121139C9.75843 0.0702215 9.85178 0.0471441 9.94499 0.0556057C10.0382 0.0640673 10.1259 0.103578 10.194 0.167805C10.262 0.232032 10.3066 0.317256 10.3205 0.409818C10.3343 0.502379 10.3167 0.596918 10.2705 0.678282L4.14189 6.80685C4.10475 6.84895 4.0594 6.88302 4.00863 6.90697C3.95785 6.93092 3.90272 6.94425 3.84661 6.94614Z",
    fill: "#0BA186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b937e00e40adff1218a3ddbc6df8c885.svg";
export { ForwardRef as ReactComponent };